<div class="header_hero-bg"></div>

<div class="report-trade-container container-fluid">
  <div class="row report_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 report_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="report_header-information__sub-header" id="report-title">
            REMIC Upload Collateral
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding">
      <div class="line-break"></div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 banner-align">
      <ng-container *ngIf="hasFileExtensionError">
        <div class="error-banner-container row">
          <div class="col-1">
            <div class="status-icon">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-9">
            <p class="file-format-text">File extension has to be xls based only.</p>
          </div>
          <div class="col-2">
            <div class="exit-button float-end" (click)="hasFileExtensionError = false">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <div class="upload-file-container">
          <div class="row">
            <ng-container>
              <div
                class="drag-drop-file-container"
                invdFileDragDrop
                [ngClass]="{ active: dropzoneActive }"
              >
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <span><i class="fa fa-upload file-upload-arrow"></i></span>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <p class="drag-file-to-upload-header">Select File to Upload</p>
                </div>
              </div>
              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12"
                style="text-align: center; margin-top: -87px"
              >
                <input
                  type="file"
                  style="display: none"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  (change)="onREMICUpload($event)"
                  #file
                  (click)="resetInput($event)"
                />
                <button
                  class="button fm-primary-button select-file-button"
                  id="select-file-button"
                  (click)="file.click()"
                >
                  Select File
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-5 col-lg-5">
        <h6 class="file-specifications">FILE SPECIFICATIONS:</h6>
        <p class="file-spec-info-text">
          Files must be in Excel-based format. Collateral tab must be present and contains data. The
          file name has to match the STTS deal name for which you are uploading (e.g.,
          22f001.xls).You may upload as many times as needed.
        </p>
        <p>New files will override the older file.</p>
      </div>

      <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
    </div>
  </div>

  <ng-container *ngIf="displayUploadSuccessPopup">
    <div class="file-upload-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="displayUploadSuccessPopup = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          <img class="img-height" alt="" src="assets/images/icon_success.svg" />
          <p>Upload Complete.</p>
          <button
            class="button fm-tertiary-button select-file-button"
            (click)="displayUploadSuccessPopup = false"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="displayUploadErrorPopup">
    <div class="file-upload-model-window">
      <div class="panel panel-default">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="displayUploadErrorPopup = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body">
          <img class="img-height" alt="" src="assets/images/icon_error.svg" />
          <p>The file you uploaded failed . Please review and upload another file.</p>
          <button
            class="button fm-tertiary-button select-file-button"
            (click)="displayUploadErrorPopup = false"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
